import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, XIcon } from '../lib/icons';
const RECENT_SALES = [{
  name: 'Romina S.',
  location: 'Córdoba'
}, {
  name: 'Gabriela M.',
  location: 'Rosario'
}, {
  name: 'Soledad P.',
  location: 'Buenos Aires'
}, {
  name: 'Mariana L.',
  location: 'Mendoza'
}, {
  name: 'Florencia R.',
  location: 'La Plata'
}, {
  name: 'Valentina T.',
  location: 'Tucumán'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const initialTimeout = setTimeout(() => setIsVisible(true), 4000);
    const cycleInterval = setInterval(() => {
      setIsAnimatingOut(true);
      setTimeout(() => {
        setIsVisible(false);
        setIsAnimatingOut(false);
        setTimeout(() => {
          setCurrentIndex(prev => (prev + 1) % RECENT_SALES.length);
          setIsVisible(true);
        }, 200);
      }, 300);
    }, 7000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(cycleInterval);
    };
  }, []);
  const handleDismiss = () => {
    setIsAnimatingOut(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsAnimatingOut(false);
    }, 300);
  };
  const currentSale = RECENT_SALES[currentIndex];
  if (!isVisible && !isAnimatingOut) return null;
  return <div className={`fixed bottom-4 left-4 z-40 max-w-xs md:max-w-sm ${isAnimatingOut ? 'animate-popup-out' : 'animate-popup-in'}`} data-id="element-226">
      <div className="bg-white rounded-lg p-4 shadow-2xl border border-gray-200 relative group" data-id="element-227">
        <button onClick={handleDismiss} className="absolute top-2 right-2 text-gray-300 hover:text-gray-600 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-228">
          <XIcon size={14} data-id="element-229" />
        </button>

        <div className="flex items-start gap-3" data-id="element-230">
          <div className="bg-green-100 p-2 rounded-full mt-0.5" data-id="element-231">
            <CheckCircle2Icon className="w-5 h-5 text-green-600" data-id="element-232" />
          </div>
          <div data-id="element-233">
            <p className="text-sm text-gray-800 font-medium leading-tight" data-id="element-234">
              <span className="font-bold text-gray-900" data-id="element-235">
                {currentSale.name}
              </span>{' '}
              de {currentSale.location}
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-236">
              acaba de adquirir el{' '}
              <span className="text-amber-600 font-semibold" data-id="element-237">
                MegaPack Reiki
              </span>
            </p>
            <div className="flex items-center gap-1 mt-2" data-id="element-238">
              <span className="text-[10px] text-gray-400 uppercase tracking-wider font-semibold" data-id="element-239">
                Verificado por Hotmart
              </span>
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-240"></div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}